const VideoBanner = props => {
  return <div className='scroll__background'>
    <div className='events__video_banner parallax__image' data-scroll data-scroll-speed='1'>
    </div>
  </div>
}

export default VideoBanner